import type { ReactNode } from 'react';

export const symbol_file_copy_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m626-902 196 196q8 8 13 19.28 5 11.28 5 23.72v390q0 14.87-9.32 21.94-9.32 7.06-20.5 7.06t-20.68-7.25Q780-258.5 780-273v-389H623q-18.75 0-31.87-13.13Q578-688.25 578-707v-153H230q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h353q12.44 0 23.72 5T626-902ZM260-220h394L260-614v394Zm454 60H260q-24 0-42-18t-18-42v-454L62-812q-9-9-9-21.5t9-21.5q9-9 21.5-9t21.5 9l751 751q9 9 9 21t-9 21q-9 9-21.5 9T813-62l-99-98ZM520-561Zm-63 144ZM140-40q-24 0-42-18t-18-42v-549q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v549h508q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q660.75-40 648-40H140Z"
		/>
	</svg>
);
